import React from "react";
import { Modal, Form, Input } from "antd";
import fetchHandler from "@/fetch/fetchHandler";
import { addMaterialsUse } from "@/fetch/fetchApi";

class RemarkModal extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  // 设置Form的ref
  formRef = React.createRef();

  handleSubmit = () => {
    const { validateFields } = this.formRef.current;

    validateFields()
      .then((values) => {
        fetchHandler(addMaterialsUse, {
          id: this.props.record.key,
          ...values,
        }).then((res) => {
          if (res && res.code === "success") {
            this.props.refresh();
            this.props.onCancel();
          }
        });
      })
      .catch(() => {
        // console.log(values);
      });
  };

  render() {
    return (
      <Modal title={this.props.record.key ? '编辑用途':'新增用途'} visible onCancel={this.props.onCancel} onOk={this.handleSubmit}>
        <Form labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} ref={this.formRef}>
          <Form.Item
            label="用途名称"
            initialValue={this.props.record.name}
            name="name"
            rules={[{ required: true, message: "请输入用途名称" }]}>
            <Input placeholder="请输入用途名称"></Input>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default RemarkModal;



// WEBPACK FOOTER //
// ./src/AntD/pages/system/useManagement/AddModal.js